import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-dropdown-menu-portal',
  templateUrl: './user-dropdown-menu-portal.component.html',
  styleUrls: ['./user-dropdown-menu-portal.component.scss']
})
export class UserDropdownMenuPortalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
